import { Component, Input } from "@angular/core";

import { SmsSenderAgentsService } from "../../../core/api/services/sms-sender-agents.service";
import { BaseSelectSearch } from "./base/base-select-search.component";
import { BaseSelectSearchModule } from "./base/base-select.search.module";

@Component({
    selector: "sms-sender-agent-select-search",
    templateUrl: "./base/base-select-search-template.html",
    imports: [BaseSelectSearchModule]
})
export class SmsSenderAgentSelectSearchComponent extends BaseSelectSearch {
  @Input("type") type: "smsSenderAgent" | "userAgentsByCp" = "smsSenderAgent";

  constructor(protected currentService: SmsSenderAgentsService) {
    super();
  }

  initConfig() {
    this.optionValue = "id";
    this.optionTitle = "name";
  }

  getItemsApi() {
    switch (this.type) {
      case "smsSenderAgent":
        this.currentService
          .smsSenderAgentsGetUserAgents()
          .pipe(this.basePipeOperators())
          .subscribe({
            next: (items) => {
              this.items = items.data;
              this.setDefaultValue();
            },
            error: (error) => {
              this.emitError();
            },
          });
        break;
      case "userAgentsByCp":
        this.currentService
          .smsSenderAgentsGetUserAgentsByCp({
            body: { smsSenderAgentReference: this.id },
          })
          .pipe(this.basePipeOperators())
          .subscribe({
            next: (items) => {
              this.items = items.data;
              this.setDefaultValue();
            },
            error: (error) => {
              this.emitError();
            },
          });
        break;
    }
  }
}
